import { useSupportEmail } from "hooks/useSupportEmail";
import { useEventTracking } from "hooks/useEventTracking";
import { Card, CardContent } from "components/ui/card";

export const Contact: React.FC = () => {
    const supportEmail = useSupportEmail();
    const { track } = useEventTracking();

    return (
        <div className="relative flex flex-col items-center">
            <div className="mt-5 flex w-full min-w-0 animate-fade-in flex-col items-center gap-10 opacity-0">
                <Card variant="glass" maxWidth="none" padding="default" className="flex flex-col items-start gap-6 w-full translate-y-[-1rem] ">
                    <CardContent variant="custom" padding="none" className="flex flex-col items-start gap-4 w-full">
                    <p className="type-body-m text-foundation-base-darkbase-dark-500">
                        For inquiries unrelated to emergency services, email{" "}
                        <a
                            href={`mailto:${supportEmail}`}
                            className="hover:underline font-semibold text-[length:var(--body-m-semibold-font-size)] tracking-[var(--body-m-semibold-letter-spacing)] leading-[var(--body-m-semibold-line-height)] [font-style:var(--body-m-semibold-font-style)]"
                            onClick={() => {
                                track("button_click", {
                                    action: "support_cta_click",
                                    control_id: "contact_support_email",
                                    support_target: "email",
                                    support_surface: "contact_page",
                                    destination: `mailto:${supportEmail}`,
                                });
                            }}
                        >
                        {supportEmail}
                        </a>
                    </p>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
};
